/**
 * WatermillMessageData 类型和 Schema 定义
 *
 * ⚠️ 注意: 此文件由脚本自动生成，请勿手动修改
 * 如需更新，请运行代码生成脚本
 */
import type { SchemaDefinition } from './_schema'

/**
 * WatermillMessageData
 */
export interface WatermillMessageData {
  offset?: number
  uuid?: string
  created_at?: string
  payload?: string
  metadata?: string
  transaction_id?: string
  consumed?: boolean
  consumed_by?: string[]
}

/**
 * WatermillMessageData Schema
 */
export const WatermillMessageDataSchema: SchemaDefinition = {
  properties: {
    offset: {
      format: 'int64',
      type: 'integer',
    },
    uuid: {
      format: 'string',
      type: 'string',
    },
    created_at: {
      format: '*time.Time',
      type: 'string',
    },
    payload: {
      format: 'string',
      type: 'string',
    },
    metadata: {
      format: 'string',
      type: 'string',
    },
    transaction_id: {
      format: 'string',
      type: 'string',
    },
    consumed: {
      format: 'bool',
      type: 'boolean',
    },
    consumed_by: {
      format: '[]string',
      items: {
        format: 'string',
        type: 'string',
      },
      type: 'array',
    },
  },
  type: 'object',
}
